import { num } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Store } from "lucide-react";

export const CHANNELS = {
  negozio: { label: "Solo negozio", cls: "border-amber-500/20 bg-amber-500/10 text-amber-400", bar: "bg-amber-400" },
  online: { label: "Solo online", cls: "border-sky-500/20 bg-sky-500/10 text-sky-400", bar: "bg-sky-400" },
  entrambi: { label: "Negozio + online", cls: "border-emerald-500/20 bg-emerald-500/10 text-emerald-400", bar: "bg-emerald-400" },
  nessun_ordine: { label: "Nessun ordine 2026", cls: "border-slate-500/20 bg-slate-500/10 text-slate-300", bar: "bg-slate-400" },
};
const KEYS = ["negozio", "entrambi", "online"];

const Split = ({ row }) => (
  <div className="flex h-2 overflow-hidden rounded-full bg-muted">
    {KEYS.map((k) => row[k] > 0 && <div key={k} className={CHANNELS[k].bar} style={{ width: `${(row[k] / row.total) * 100}%` }} />)}
  </div>
);

export const StoreArea = ({ stats, onChannel }) => {
  const ch = stats.channels;
  return (
    <Card className="mb-6 p-5" data-testid="store-area">
      <div className="mb-4 flex items-center gap-2">
        <Store className="h-4 w-4 text-primary" />
        <h3 className="font-display text-base font-semibold">Negozio di Valeggio sul Mincio · clienti per canale (ordini dal 2026)</h3>
      </div>
      <div className="mb-5 grid grid-cols-2 gap-3 md:grid-cols-4">
        {Object.entries(CHANNELS).map(([k, v]) => (
          <button key={k} onClick={() => onChannel(k)} data-testid={`channel-kpi-${k}`}
            className={`rounded-md border p-3 text-left transition-colors hover:opacity-80 ${v.cls}`}>
            <p className="font-display text-xl font-bold">{num(ch[k])}</p>
            <p className="text-xs">{v.label}</p>
          </button>
        ))}
      </div>
      <p className="mb-2 font-mono-erp text-[11px] uppercase tracking-widest text-muted-foreground">Province vicine al negozio</p>
      <div className="space-y-2.5">
        {stats.store_area.map((r) => (
          <div key={r.province} className="grid grid-cols-12 items-center gap-3 text-sm" data-testid={`store-province-${r.province}`}>
            <span className="col-span-2 font-medium">{r.province}</span>
            <span className="col-span-1 text-right font-semibold">{num(r.total)}</span>
            <div className="col-span-5">{r.total > 0 && <Split row={r} />}</div>
            <span className="col-span-4 text-xs text-muted-foreground">
              negozio {num(r.negozio)} · entrambi {num(r.entrambi)} · online {num(r.online)}
            </span>
          </div>
        ))}
      </div>
      <p className="mt-4 text-xs text-muted-foreground" data-testid="store-no-address">
        Senza indirizzo in anagrafica (spesso clienti registrati solo in cassa): negozio {num(stats.store_no_address.negozio)} · entrambi {num(stats.store_no_address.entrambi)} · online {num(stats.store_no_address.online)}
      </p>
    </Card>
  );
};
